export enum entiteTypeEnum {
  cmp= 1,
  dir= 2
}
